var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_26872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21H4.5C4.1023 20.9996 3.72101 20.8414 3.4398 20.5602C3.15859 20.279 3.00042 19.8977 3 19.5V8.25C3.00042 7.8523 3.15859 7.47101 3.4398 7.1898C3.72101 6.90859 4.1023 6.75042 4.5 6.75H8.74988C9.07451 6.75053 9.39031 6.85573 9.6504 7.05L12.2501 9H19.5C19.8977 9.00042 20.279 9.15859 20.5602 9.4398C20.8414 9.72101 20.9996 10.1023 21 10.5V19.5C20.9996 19.8977 20.8414 20.279 20.5602 20.5602C20.279 20.8414 19.8977 20.9996 19.5 21ZM8.74988 8.25H4.49887L4.5 19.5H19.5V10.5H11.7499L8.74988 8.25Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.75H13.2499L10.2499 4.5H4.5V3H10.2499C10.5745 3.00053 10.8903 3.10573 11.1504 3.3L13.7501 5.25H21V6.75Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_26872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectSettings);
export default __webpack_public_path__ + "static/media/projectSettings.bc6da0b3330df170a72bdbf6f8a03261.svg";
export { ForwardRef as ReactComponent };